import React, { Component } from "react";
import Auth from "../js/auth";
import SpotifyAPI from "../js/spotifyapi";

class AuthComponent extends Component {
  state = {
    isLoadingUser: false,
    isAuthenticated: false,
    user: "",
    imageURL: "",
  };

  async componentDidMount() {
    this.setState({ isLoadingUser: true });
    await Auth.handleRedirect();
    this.setState({ isAuthenticated: Auth.checkIsAuthenticated() });
    if (this.state.isAuthenticated) {
      const user = await SpotifyAPI.getSpotifyUser();
      this.setState({ user });
      this.setState({ imageURL: user.images[0]?.url });
    }
    this.setState({ isLoadingUser: false });
    this.props.onAuthChange(this.state.isAuthenticated);
  }

  handleClick = async () => {
    if (this.state.isAuthenticated === false) {
      this.setState({ isLoadingUser: true });
      await Auth.loginWithRedirect();
    } else {
      Auth.clearSession();
      this.setState({ isAuthenticated: Auth.checkIsAuthenticated() });
      this.props.onAuthChange(this.state.isAuthenticated);
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.state.isLoadingUser ? (
          <div className="text-center mt-3">
            <div className="spinner-border" role="status"></div>
          </div>
        ) : (
          <nav className="navbar bg-light">
            <div className="container-fluid">
              {this.state.isAuthenticated && (
                <img
                  src={this.state.imageURL}
                  width="30"
                  height="30"
                  className="d-inline-block align-top rounded-circle"
                />
              )}
              <a className="navbar-brand" href="#">
                {this.state.isAuthenticated
                  ? `Hola ${this.state.user.display_name}!`
                  : "Spotify Playlist App"}
              </a>
              <form className="d-flex" role="login">
                <button
                  onClick={() => this.handleClick()}
                  className={`btn ${
                    this.state.isAuthenticated
                      ? "btn-outline-danger"
                      : "btn-outline-success"
                  }  bt-sm`}
                >
                  {this.state.isAuthenticated
                    ? "Cerrar sesión"
                    : "Iniciar sesión"}
                </button>
              </form>
            </div>
          </nav>
        )}
      </React.Fragment>
    );
  }
}

export default AuthComponent;
